import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, Content, Platform, ActionSheetController, ModalController } from 'ionic-angular';
import { PhotoLibrary } from '../../../../providers/my-photo-library';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { CallNumber } from '@ionic-native/call-number';
import { AbstractPage } from '../../../_com/abstract-page';
import { ChatAction } from '../../../../actions/chat.action';
import { ReserveAction } from '../../../../actions/reserve.action';
import { PhotoAction, _PhotoAction } from '../../../../actions/photo.action';
import { InterviewSheetEditStaffPage } from "../edit-staff/reserve-interview-edit-staff";
import { Subscription } from 'rxjs/Subscription';
import Utils from '../../../../_com/utils';
import _ from 'underscore';

import { InterviewSheetEditFamilyPage } from "../edit-family/reserve-interview-edit-family";

/**
 * Generated class for the ReserveDetailPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: "page-reserve-interview-detail-staff",
  templateUrl: "reserve-interview-detail-staff.html",
})
export class InterviewSheetDetailStaffPage extends AbstractPage {
  chatText: String;
  chatList: any;
  child = {};
  family = {};
  reserve = {};
  interviewId = "";
  interviewInfo = {};
  reserveHistory = null;
  reservePhotos = null;
  isDataExists = true;
  _utils = Utils;
  path = "";
  captureData$: Subscription;
  captureDatas$: Subscription;
  onChangeChildDetail: Subscription;

  data = {
    id: "",
    child: {},
    reserve: {},
    interviewInfo: {
      temperature_parent: "",
      temperature_staff: "",
      arrange_description: "",
      bath_description: "",
      tabetakotoaru_foods_new: "",
      use_drug: null,
      use_drug_description: "",
      injured: null,
      injurd_description: "",
      nap_description: "",
      other_questions: [],
      take_a_bath: null,
      notice: "",
      // - 食札（スタッフ専用)
      shokusatsu_pictures: [],
      // - スタッフ専用 ファイル添付
      staff_only_files: [],
    },
  };

  @ViewChild(Content) content: Content;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public chatAction: ChatAction,
    public reserveAction: ReserveAction,
    public tmpPhotoAction: PhotoAction,
    private actionSheetController: ActionSheetController,
    private modalController: ModalController,
    private pv: PhotoViewer,
    private pl: PhotoLibrary,
    private plt: Platform,
    private callNumber: CallNumber
  ) {
    super();

    this.child = this.navParams.data.child.Child; // 子どものID
    this.reserve = this.navParams.data.reserve; // 予約ID
    // 上記の条件で問診票を特定する

    this.pl; //for TSLint
    this.pv; //for TSLint
    this.plt; //for TSLint
    this.callNumber; //for TSLint
  }

  /**
   * 画面が呼び出される前にロード
   */
  ionViewDidLoad() {
    this.reserveAction
      .getInterviewData({
        reserveId: this.reserve["id"],
        childId: this.child["id"],
      })
      .subscribe((res) => {
        // ここでデータを取得する
        if (res.data.length > 0) {
          // データ画面に反映
          this.interviewInfo = res.data[0]["InterviewSheet"]["interviewInfo"];
          this.interviewId = res.data[0]["InterviewSheet"]["id"];
        } else {
          // 入力されていない旨を表示する
          this.isDataExists = false;
        }
      });
  }

  /**
   * 編集ページへ移動する
   */
  goEdit() {
    let data = {
      interviewInfo: this.interviewInfo,
      child: this.child,
      reserve: this.reserve,
      interviewId: this.interviewId,
      isDetail: true,
    };
    // this.navCtrl.push(InterviewSheetEditStaffPage, data);

    // アクションシートで選択可能にしておく
    let actionSheet = this.actionSheetController.create({
      title: "問診票を編集",
      buttons: [
        // スタッフ 選択画面
        {
          text: "スタッフが記入する",
          handler: () => {
            // スタッフが記入する画面
            this.navCtrl.push(InterviewSheetEditStaffPage, data);
          },
        },
        // ご家族 選択画面
        {
          text: "ご家族に記入いただく",
          handler: () => {
            // 記入頂く
            const modal = this.modalController.create(
              InterviewSheetEditFamilyPage,
              data,
              { enableBackdropDismiss: false }
            );
            modal.onDidDismiss(() => {
              // 戻ってきたら画面をリフレッシュする
              this.ionViewDidLoad();
            });

            modal.present();
          },
        },
        {
          text: "キャンセル",
          role: "cancel",
        },
      ],
    });
    actionSheet.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/reserve/interview/detail-staff/reserve-interview-detail-staff.ts